(function () {
  'use strict';

  function syncBrowserThemeColor(bar) {
    const themeColor = document.querySelector('meta[name="theme-color"]');
    const background = window.getComputedStyle(bar).backgroundColor;
    if (themeColor && background && background !== 'transparent' && background !== 'rgba(0, 0, 0, 0)') {
      themeColor.setAttribute('content', background);
    }
  }

  function initBar(bar) {
    syncBrowserThemeColor(bar);
    const speed   = parseInt(bar.dataset.rotateSpeed, 10) * 1000 || 5000;
    const slides  = bar.querySelectorAll('.announcement-bar__slide');
    const prevBtn = bar.querySelector('.announcement-bar__nav--prev');
    const nextBtn = bar.querySelector('.announcement-bar__nav--next');

    if (slides.length <= 1) return;

    let current = 0;
    let timer   = null;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function goTo(index) {
      const prev = current;
      current = (index + slides.length) % slides.length;

      slides[prev].classList.add('is-leaving');
      slides[prev].classList.remove('is-active');
      slides[prev].setAttribute('aria-hidden', 'true');
      slides[prev].setAttribute('inert', '');

      slides[current].classList.add('is-active');
      slides[current].classList.remove('is-leaving');
      slides[current].setAttribute('aria-hidden', 'false');
      slides[current].removeAttribute('inert');

      setTimeout(() => slides[prev].classList.remove('is-leaving'), 450);
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startTimer() {
      if (reduceMotion || document.hidden) return;
      clearInterval(timer);
      timer = setInterval(next, speed);
    }

    function stopTimer() { clearInterval(timer); }

    startTimer();

    if (nextBtn) {
      nextBtn.addEventListener('click', () => { stopTimer(); next(); startTimer(); });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', () => { stopTimer(); prev(); startTimer(); });
    }

    // Pause on hover (desktop)
    bar.addEventListener('mouseenter', stopTimer);
    bar.addEventListener('mouseleave', startTimer);
    bar.addEventListener('focusin', stopTimer);
    bar.addEventListener('focusout', function (event) {
      if (!bar.contains(event.relatedTarget)) startTimer();
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopTimer(); else startTimer();
    });

    // ── Touch swipe (mobile) — no arrows are rendered on mobile, so swipe
    //    is the only way for users to skip ahead manually. ──
    let touchStartX = 0;
    let touchStartY = 0;
    let touchActive = false;
    const SWIPE_THRESHOLD = 30;   // px — distance required to register a swipe
    const VERTICAL_TOLERANCE = 40; // px — ignore swipes that drift too vertical

    bar.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchActive = true;
      stopTimer();
    }, { passive: true });

    bar.addEventListener('touchend', function (e) {
      if (!touchActive) return;
      touchActive = false;

      const touch = e.changedTouches[0];
      const dx = touch.clientX - touchStartX;
      const dy = touch.clientY - touchStartY;

      // Reject swipes that are too vertical — likely a page scroll, not a swipe
      if (Math.abs(dy) > VERTICAL_TOLERANCE) {
        startTimer();
        return;
      }

      if (dx <= -SWIPE_THRESHOLD)       next();
      else if (dx >= SWIPE_THRESHOLD)   prev();
      startTimer();
    }, { passive: true });

    bar.addEventListener('touchcancel', function () {
      touchActive = false;
      startTimer();
    });
  }

  function init() {
    document.querySelectorAll('.announcement-bar').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section events (Theme Editor live reload)
  document.addEventListener('shopify:section:load', function (e) {
    const bar = e.target.querySelector('.announcement-bar');
    if (bar) initBar(bar);
  });
})();
